<div class="row">
  <div class="col-12">
    <h2 class="ml-4">{{editorType === 'edit' ?
      ('CONFIG.call-status.edit-status' | translate) :
      ('CONFIG.call-status.add-status' | translate)
      }}</h2>
  </div>
</div>

<div *ngIf="isLoading" class="row">
  <div class="col-12 pt-5 text-center">
    <mat-spinner class="m-0 m-auto"></mat-spinner>
  </div>
</div>

<div *ngIf="!isLoading" class="row">
  <div class="col-12">
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="card shadow mb-5">
        <div class="card-body">
          <div class="row">
            <app-input type="text" formControlName="name_en" appearance="fill" [fullWidth]="true" class="col-6"
              [label]="'CONFIG.call-status.en-name' | translate"
            ></app-input>
            <app-input type="text" formControlName="name_es" appearance="fill" [fullWidth]="true" class="col-6"
                       [label]="'CONFIG.call-status.es-name' | translate"
            ></app-input>
          </div>
          <div class="row pt-5">
            <div class="col-md-4">
              <button mat-raised-button color="primary" class="ml-3" type="submit">
                {{ this.editorType === 'edit' ?
                ('CONFIG.call-status.edit-status' | translate) :
                ('CONFIG.call-status.add-status' | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
